import { Link as RouterLink } from "react-router-dom";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { useLang } from "../i18n/LangContext";
import { loadPosts } from "../content/blog";
import { SEOHead, SITE_URL } from "../components/SEOHead";

export function BlogIndexPage() {
  const { t, lang } = useLang();
  const posts = loadPosts();

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Blog",
    name: t("blogTitle"),
    url: `${SITE_URL}/blog`,
    inLanguage: lang,
    description: t("blogLead"),
    blogPost: posts.map((p) => ({
      "@type": "BlogPosting",
      headline: p.title,
      datePublished: p.date,
      url: `${SITE_URL}/blog/${p.slug}`,
      description: p.description,
    })),
  };

  return (
    <>
      <SEOHead
        title={t("blogTitle")}
        description={t("blogLead")}
        path="/blog"
        jsonLd={jsonLd}
      />
      <main className="page page--text">
        <header className="page-head">
          <Typography variant="h3" component="h1" sx={{ fontWeight: 700 }}>
            {t("blogTitle")}
          </Typography>
          <Typography variant="body1" sx={{ mt: 1, color: "text.secondary" }}>
            {t("blogLead")}
          </Typography>
        </header>

        {posts.length === 0 ? (
          <Typography sx={{ color: "text.secondary", mt: 4 }}>{t("blogEmpty")}</Typography>
        ) : (
          <div className="blog-grid">
            {posts.map((p) => (
              <Card key={p.slug} variant="outlined">
                <CardActionArea component={RouterLink} to={`/blog/${p.slug}`}>
                  <CardContent>
                    <Typography variant="caption" sx={{ color: "text.secondary" }}>
                      {p.date} · {p.readingTime} {t("blogReadingTime")}
                    </Typography>
                    <Typography
                      variant="h6"
                      component="h2"
                      sx={{ mt: 0.5, fontWeight: 700 }}
                    >
                      {p.title}
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 1, color: "text.secondary" }}>
                      {p.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            ))}
          </div>
        )}
      </main>
    </>
  );
}
